import { filter } from 'rxjs/operators';

export const isNotNull = <T extends {}>(arg: T | null | undefined): arg is T => arg != null;

export const filterNulls = <T extends {}>() => filter<T | null | undefined, T>(isNotNull);

export type PickNonNullable<T, K extends keyof T = keyof T> = T & {
  [P in K]-?: NonNullable<T[P]>;
};
